
<div
  class="Whiteboard"
  :class="{
    'm-black': hasBackgroundImage,
    'm-iframe': $store.state.isInIframe,
  }"
>
  <div
    :class="{
      wbroot: true,
      'm-loading': !isLoaded,
      'm-black': hasBackgroundImage,
    }"
    ref="wbroot"
    v-on:wheel="onWheel"
  ></div>

  <div v-if="!isLoaded" class="LoadingIndicator">
    <LoadingSpinner></LoadingSpinner>
  </div>

  <DropTarget v-if="$store.state.dragState === 'dragging'"></DropTarget>

  <ActiveUserList v-if="!$store.state.isInIframe"></ActiveUserList>
  <TopToolbarStack>
    <TopBar
      v-if="!$store.getters.hasFolder && !$store.state.isInIframe"
      v-on:editname="maybeOpenGuestUsernameModal"
    ></TopBar>
    <AuxHUD
      v-if="canWrite"
      v-on:deleteSelection="deleteSelection"
      v-on:duplicateSelectedShapes="duplicateSelectedShapes"
      v-on:undo="undo"
      v-on:redo="redo"
    ></AuxHUD>
  </TopToolbarStack>
  <ToolPickerHUD v-if="canWrite" :config="config"></ToolPickerHUD>
  <ZoomControls
    v-if="!hasBackgroundImage"
    v-on:setScale="setScale"
  ></ZoomControls>

  <AllModals v-on:clearWhiteboard="clearWhiteboard"></AllModals>

  <a
    v-if="state.featureFlags.feedback_prompt && !$store.state.isInIframe"
    class="CircleShadowButton m-variable-width FeedbackButton DesktopOnly"
    target="_"
    href="https://docs.google.com/forms/d/e/1FAIpQLSd9x3Cg0OzgSQD6Cv1t1OHp48Fa2x2B3JxrDl4W2ZFHJRwQpA/viewform?usp=sf_link"
    >Send feedback</a
  >

  <OfflineIndicator v-if="canWrite" />
</div>
